/**
 * Ingredients Grid Section
 * Handles ingredient link to scroll to product template toggle
 * and tabs navigation for pack products
 */

class IngredientsGrid {
  constructor(container) {
    this.container = container || document.querySelector('.section-ingredients-grid');

    if (!this.container) return;

    this.ingredientLinks = this.container.querySelectorAll('[data-ingredient-link]');
    this.tabButtons = this.container.querySelectorAll('.section-ingredients-grid__tab-button');
    this.tabPanels = this.container.querySelectorAll('.section-ingredients-grid__tab-panel');

    this.init();
  }

  init() {
    this.initIngredientLink();
    this.initTabs();
  }

  initIngredientLink() {
    this.ingredientLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // Find the ingredient toggle in product template
        const ingredientToggle = document.querySelector('[data-is-ingredient="true"]');

        if (ingredientToggle) {
          // Scroll to the toggle with smooth behavior
          ingredientToggle.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          // Wait for scroll to complete, then open the toggle
          setTimeout(() => {
            const trigger = ingredientToggle.querySelector('[data-collapse-trigger]');
            const isExpanded = trigger?.getAttribute('aria-expanded') === 'true';

            // Only click if it's not already expanded
            if (trigger && !isExpanded) {
              trigger.click();
            }
          }, 500);
        }
      });
    });
  }

  initTabs() {
    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) return;

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetTab = button.getAttribute('data-tab');

        // Remove active class from all buttons
        this.tabButtons.forEach((btn) => btn.classList.remove('active'));

        // Add active class to all buttons with the same data-tab (one in each panel)
        const matchingButtons = this.container.querySelectorAll(`[data-tab="${targetTab}"]`);
        matchingButtons.forEach((btn) => btn.classList.add('active'));

        // Remove active class from all panels
        this.tabPanels.forEach((panel) => panel.classList.remove('active'));

        // Add active class to the corresponding panel
        const targetPanel = this.container.querySelector(`[data-panel="${targetTab}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  const ingredientsSection = document.querySelector('.section-ingredients-grid');
  if (ingredientsSection) {
    new IngredientsGrid(ingredientsSection);
  }
});

// Expose class globally for dynamic initialization
window.IngredientsGrid = IngredientsGrid;
